import { render, staticRenderFns } from "./component-renderer.vue?vue&type=template&id=21f66a6a"
import script from "./component-renderer.vue?vue&type=script&lang=js"
export * from "./component-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports